import { IContactEntityType } from "..";
import { IEmailAddressField } from "./index";

export interface IEmailSendeeListResponse {
    data: {
        success: boolean;
        message: string;
        results: {
            emailAddressFields: IEmailAddressField[],
            contactEntityTypes: IContactEntityType[]
        }
    }
}